export default {
  submitBtn: false,
  labelPosition: 'top',
  column: []
};
